import React from 'react'
import { FCC } from 'types'

const SmartEngegementCard: FCC<{
 type?: 'primary' | 'secondary'
 title?: string
}> = ({ children, title, type = 'primary' }) => {
 return (
  <div data-type={type} className="smart-engegement-card">
   <div className="smart-engegement-card-header">
    <h2>{title}</h2>
   </div>
   <div className="smart-engegement-card-body">
    <div className="smart-engegement-card-content">{children}</div>
   </div>
  </div>
 )
}

export default SmartEngegementCard
